import { Box, Stack, Typography } from '@mui/material';

import { capitalizeFirstLetter } from 'features/common/utils';

import styles from '../Map.module.css';

interface IMapTooltip extends React.HTMLAttributes<HTMLDivElement> {
  title?: string;
  data?: Record<string, string | number>;
}
export default function MapTooltip({ title, data, ...divProps }: IMapTooltip) {
  const getTitle = (val: string) => {
    return val
      .split('_')
      .map((el) => capitalizeFirstLetter(el))
      .join(' ');
  };

  return (
    <Box {...divProps} className={styles.mapTooltip}>
      {title && <Typography variant="body2">{title}</Typography>}
      <Stack className={styles.mapTooltipContent}>
        {Object.entries(data).map(([key, value]) => (
          <Box key={key}>
            <Typography variant="body2">{getTitle(key)}</Typography>
            <Typography variant="body2">{value}</Typography>
          </Box>
        ))}
      </Stack>
    </Box>
  );
}
